import { Component, Input } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from '../ag-grid.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-numeric-text-renderer',
  templateUrl: './numeric-text-renderer.component.html',
  styleUrls: ['./numeric-text-renderer.component.scss']
})
export class NumericTextRendererComponent implements ICellRendererAngularComp {
  @Input() params    : ICellRendererParams | any;
  value     : any;
  isCursor: boolean = false;
  isWeight  = false; 
  isAmt     = false;
  isPercent = false;
  @Input() isDirectRender = false
  constructor(public agGridService: AgGridService) {}

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.setParamsAndAssign(params);
    this.isCursor = this.params?.isCursor??false;
  }

  ngOnChanges(){
    if(this.isDirectRender){
      this.setParamsAndAssign(this.params)
    }
  }

  setParamsAndAssign(params){
    this.params    = params;
    this.formatValue();
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.setParamsAndAssign(params);
    this.isCursor = this.params?.isCursor??false;
    return true
  }

  onClick(event){
    this.isCursor ? this.agGridService.triggerOnNumberClick(this.params):null
  }

  formatValue() {
    this.value = this.params?.value;
    this.value = this.removeNegativeSign(this.value);
  }

  formattedValue(): string {
    if (this.isNegative()) {
      return `(-${this.removeNegativeSign(this.value)})`;
    } else {
      return this.isPercent ? `${this.value}%` : this.value;
    }
  }

  
  isNegative(): boolean {
    return this.params?.value < 0;
  }

  isNegativeFormatted(str: string | undefined): boolean {
    return typeof str === 'string' && /^\(-\d+\)$/.test(str);
  }

  isDecimal(value: number): boolean {
    return Number.isInteger(value) === false;
  }

  removeNegativeSign(value: string | number): string {
    const stringValue = value?.toString();
    return stringValue?.startsWith('-') ? `(${stringValue})` : stringValue;
  }
  
}
